function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.994 2a10 10 0 1010 10 10 10 0 00-10-10zm3.18 15.152a.705.705 0 01-1.002.352l-2.715-2.11-1.742 1.608a.3.3 0 01-.285.039l.334-2.989.01.009.007-.059s4.885-4.448 5.084-4.637c.202-.189.135-.23.135-.23.012-.23-.361 0-.361 0l-6.473 4.164-2.695-.918s-.414-.148-.453-.475c-.041-.324.466-.5.466-.5l10.717-4.258s.881-.392.881.258z"
});

function SvgShareTg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#55AB3A",
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    "data-name": "Layer 1"
  }, props), _ref);
}

export default "/app/dist/assets/share-tg.svg";
export { SvgShareTg as ReactComponent };